import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import type { BlogPost } from "@/data/blogPosts";

interface Props {
  post: BlogPost;
}

export const BlogCard = ({ post }: Props) => {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex flex-col bg-background/60 border border-gold/20 rounded-2xl overflow-hidden hover:border-gold/60 hover:shadow-[0_10px_40px_-10px_hsl(var(--gold)/0.35)] transition-all duration-500"
    >
      <div className="aspect-[16/10] overflow-hidden">
        <img
          src={post.image}
          alt={post.imageAlt}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
      </div>
      <div className="flex flex-col flex-1 p-6">
        <div className="flex items-center gap-3 mb-3 text-xs">
          <span className="uppercase tracking-widest text-gold font-semibold">
            {post.category}
          </span>
          <span className="text-primary/40">•</span>
          <span className="flex items-center gap-1 text-primary/60">
            <Clock className="w-3 h-3" /> {post.readTime}
          </span>
        </div>
        <h3 className="font-serif text-2xl font-bold text-primary group-hover:text-gold transition-colors leading-tight mb-3">
          {post.title}
        </h3>
        <p className="text-primary/70 leading-relaxed mb-6 flex-1">
          {post.excerpt}
        </p>
        <span className="inline-flex items-center gap-2 text-gold font-medium group-hover:gap-3 transition-all">
          Lees meer <ArrowRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
};
